import { chalkLine, chalkText } from '../../primitives/chalk';

export async function prepareDividerNode(env, spec) {
  const area = env.boardArea();
  const fontSize = env.getStyle('bodySize');

  const lineY =
    spec.line.y === 'center'
      ? area.y + area.h / 2
      : typeof spec.line.y === 'number'
        ? spec.line.y
        : area.y + area.h / 2;

  return {
    lineY,
    lineX1: area.x,
    lineX2: area.x + area.w,
    strokeWidth: spec.line.strokeWidth,
    label: spec.label,
    labelX: area.x + area.w / 2,
    labelY: lineY - 10,
    fontSize,
    drawDuration: 0.4,
  };
}

export function commitDividerNode(packet, ctxs, anim) {
  let t = 0;

  anim.add((dt) => {
    t += dt;
    const progress = Math.min(t / packet.drawDuration, 1);

    const lineW = (packet.lineX2 - packet.lineX1) * progress;
    chalkLine(
      ctxs.ink,
      packet.lineX1,
      packet.lineY,
      packet.lineX1 + lineW,
      packet.lineY,
      packet.strokeWidth,
      0.9
    );

    if (progress >= 1 && packet.label) {
      chalkText(
        ctxs.ink,
        packet.label,
        packet.labelX,
        packet.labelY,
        packet.fontSize,
        0.9,
        'sans-serif',
        'center'
      );
    }

    if (progress < 1) return true;
    if (packet.label && t < packet.drawDuration + 0.2) return true;
    return false;
  });
}
